export default {
    BASE_URL: '',
    api: [
        {
            name: 'date',
            desc: '服务器当前时间',
            method: 'GET',
            path: 'index/findServiceTime'
        }
    ]
}


// WEBPACK FOOTER //
// ./src/api/pub/date.js